import { hc } from 'hono/client';

// src/api-client.ts
function createApiClient(baseUrl, options) {
  return {
    // Admin routes
    admin: hc(`${baseUrl}/admin`, options),
    adminProjects: hc(
      `${baseUrl}/admin/projects`,
      options
    ),
    adminConnections: hc(
      `${baseUrl}/admin/connections`,
      options
    ),
    adminConnectionUtils: hc(
      `${baseUrl}/admin/connections`,
      options
    ),
    adminConnectionOauth: hc(
      `${baseUrl}/admin/connections`,
      options
    ),
    // Dashboard routes
    dashboard: hc(`${baseUrl}/dashboard`, options),
    // Core routes
    health: hc(`${baseUrl}/health`, options),
    profile: hc(`${baseUrl}/profile`, options),
    users: hc(`${baseUrl}/users`, options),
    organizations: hc(`${baseUrl}/organizations`, options),
    notifications: hc(`${baseUrl}/notifications`, options),
    apiKeys: hc(`${baseUrl}/api-keys`, options),
    environmentVariables: hc(
      `${baseUrl}/environment-variables`,
      options
    ),
    invitations: hc(`${baseUrl}/invitations`, options),
    projects: hc(`${baseUrl}/projects`, options),
    // Request workflow routes
    requests: hc(`${baseUrl}/requests`, options),
    interview: hc(`${baseUrl}/requests`, options),
    pr: hc(`${baseUrl}/requests`, options),
    // Session routes
    sessions: hc(`${baseUrl}/sessions`, options)
  };
}

export { createApiClient };
//# sourceMappingURL=api-client.js.map
//# sourceMappingURL=api-client.js.map